export const states = ["ACT", "NSW", "VIC", "QLD", "WA", "TAS", "NT", "SA"];
